export const partnerWorkspaceTour = {
    module: 'partner_workspace',
    title: 'Partner Workspace Tour',
    title_vi: 'Tour Không gian đối tác',
    description: 'As a Partner Account Manager, onboard partner organizations, configure service tiers, track compliance deliverables, and manage the partner marketplace.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As a Partner Account Manager, onboard partner organizations, configure service tiers, track compliance deliverables, and manage the partner marketplace.',
    estimated_duration_seconds: 70,
    steps: [
        {
            step_id: 'pw_dashboard',
            navigate_to: '/admin/partner-marketplace/dashboard',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Partner Workspace Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Workspace Dashboard',
            description: 'As a Partner Account Manager, you will track all partner activity here -- active engagements, deliverable progress, and support ticket metrics across your partner ecosystem.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As a Partner Account Manager, you will track all partner activity here -- active engagements, deliverable progress, and support ticket metrics across your partner ecosystem.',
            position: 'bottom',
        },
        {
            step_id: 'pw_stats',
            target: '#partner-marketplace-stats',
            title: 'Partner Metrics',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Metrics',
            description: 'Summary cards show total partners, active service agreements, and pending deliverables. Monitor these to ensure SLA commitments are being met across your partner network.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Summary cards show total partners, active service agreements, and pending deliverables. Monitor these to ensure SLA commitments are being met across your partner network.',
            position: 'bottom',
        },
        {
            step_id: 'pw_partner_orgs',
            target: '[data-testid="partner-orgs-tab"]',
            title: 'Partner Organizations',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Organizations',
            description: 'View and manage all partner organizations. Each partner has its own profile, contact details, service tier, and compliance deliverable history.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: View and manage all partner organizations. Each partner has its own profile, contact details, service tier, and compliance deliverable history.',
            position: 'bottom',
        },
        {
            step_id: 'pw_service_tiers',
            target: '[data-testid="service-tiers-tab"]',
            title: 'Service Tiers',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Service Tiers',
            description: 'Define service tier levels that determine support scope, SLA response and resolution targets, and available compliance modules for each partner.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define service tier levels that determine support scope, SLA response and resolution targets, and available compliance modules for each partner.',
            position: 'bottom',
        },
        {
            step_id: 'pw_deliverables',
            target: '[data-testid="deliverables-tab"]',
            title: 'Partner Deliverables',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Deliverables',
            description: 'Track deliverables owed to or from partners -- compliance reports, audit outcomes, implementation milestones, and training completions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track deliverables owed to or from partners -- compliance reports, audit outcomes, implementation milestones, and training completions.',
            position: 'bottom',
        },
        {
            step_id: 'pw_support',
            target: '[data-testid="support-tab"]',
            title: 'Partner Support',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Support',
            description: 'Manage support tickets from partners. Escalation paths and SLA timers are tracked per service tier to ensure contractual commitments are met.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Manage support tickets from partners. Escalation paths and SLA timers are tracked per service tier to ensure contractual commitments are met.',
            position: 'bottom',
        },
        {
            step_id: 'pw_partner_orgs_page',
            navigate_to: '/admin/partner-marketplace/partner-orgs',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Partner Organizations',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Organizations',
            description: 'Full partner directory showing tier assignment, onboarding status, and primary contacts. Use this to manage your partner ecosystem at scale.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Full partner directory showing tier assignment, onboarding status, and primary contacts. Use this to manage your partner ecosystem at scale.',
            position: 'bottom',
        },
        {
            step_id: 'pw_partner_orgs_filters',
            target: '.dm-filters',
            title: 'Filter Partners',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Partners',
            description: 'Filter by partner status or service tier to quickly find partners needing attention or review.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by partner status or service tier to quickly find partners needing attention or review.',
            position: 'bottom',
        },
        {
            step_id: 'pw_create_partner_org',
            target: '.dm-header .btn-primary',
            title: 'Add a Partner Organization',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Partner Organization',
            description: 'Click here to onboard a new partner into the marketplace. The onboarding process captures organization details, assigns a service tier, and begins deliverable tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to onboard a new partner into the marketplace. The onboarding process captures organization details, assigns a service tier, and begins deliverable tracking.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'pw_partner_org_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Partner Organization Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Organization Form',
            description: 'Enter the organization name, contact details, service tier, and onboarding date. This creates the partner record that drives deliverable scheduling and SLA tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the organization name, contact details, service tier, and onboarding date. This creates the partner record that drives deliverable scheduling and SLA tracking.',
            position: 'right',
        },
        {
            step_id: 'pw_service_tiers_page',
            navigate_to: '/admin/partner-marketplace/service-tiers',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Service Tiers',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Service Tiers',
            description: 'Define and compare service tiers. Each tier controls seat limits, storage, SLA response/resolution times, and which compliance modules partners can access.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define and compare service tiers. Each tier controls seat limits, storage, SLA response/resolution times, and which compliance modules partners can access.',
            position: 'bottom',
        },
        {
            step_id: 'pw_service_tiers_filters',
            target: '.dm-filters',
            title: 'Filter Service Tiers',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Service Tiers',
            description: 'Filter tiers by status to manage active, draft, or deprecated tier configurations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter tiers by status to manage active, draft, or deprecated tier configurations.',
            position: 'bottom',
        },
        {
            step_id: 'pw_create_service_tier',
            target: '.dm-header div > button:last-child',
            title: 'Create a Service Tier',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Service Tier',
            description: 'Click here to define a new tier with SLA commitments and module access. Select two or more tiers to compare them side by side.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to define a new tier with SLA commitments and module access. Select two or more tiers to compare them side by side.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header div > button:last-child' },
            duration_ms: 300,
        },
        {
            step_id: 'pw_service_tier_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Service Tier Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Service Tier Form',
            description: "Enter the tier name, code, seat and storage limits, SLA response and resolution hours, and associated compliance modules. These settings define the partner's contractual service level.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the tier name, code, seat and storage limits, SLA response and resolution hours, and associated compliance modules. These settings define the partner's contractual service level.",
            position: 'right',
        },
        {
            step_id: 'pw_deliverables_page',
            navigate_to: '/admin/partner-marketplace/deliverables',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Deliverables',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Deliverables',
            description: 'Track all deliverables across partners. Select multiple rows for bulk status updates when processing end-of-quarter compliance report submissions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track all deliverables across partners. Select multiple rows for bulk status updates when processing end-of-quarter compliance report submissions.',
            position: 'bottom',
        },
        {
            step_id: 'pw_deliverables_filters',
            target: '.dm-filters',
            title: 'Filter Deliverables',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Deliverables',
            description: 'Filter by deliverable status or assignee to prioritize overdue items and track partner accountability.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by deliverable status or assignee to prioritize overdue items and track partner accountability.',
            position: 'bottom',
        },
        {
            step_id: 'pw_generate_schedule',
            target: '.dm-header button',
            title: 'Generate Schedule',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate Schedule',
            description: 'Auto-generate a full deliverable schedule for a partner based on their service tier. This creates all required compliance milestones in one step.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Auto-generate a full deliverable schedule for a partner based on their service tier. This creates all required compliance milestones in one step.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 300,
        },
        {
            step_id: 'pw_generate_schedule_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Generate Schedule Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate Schedule Form',
            description: "Select the partner organization and service tier. The system generates all tier-defined deliverables with due dates aligned to the partner's onboarding timeline.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the partner organization and service tier. The system generates all tier-defined deliverables with due dates aligned to the partner's onboarding timeline.",
            position: 'right',
        },
        {
            step_id: 'pw_support_page',
            navigate_to: '/admin/partner-marketplace/support-tickets',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Support Tickets',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Support Tickets',
            description: 'All partner support requests with status, priority, category, and escalation tier. SLA timers track response and resolution commitments per service agreement.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All partner support requests with status, priority, category, and escalation tier. SLA timers track response and resolution commitments per service agreement.',
            position: 'bottom',
        },
        {
            step_id: 'pw_support_filters',
            target: '.dm-filters',
            title: 'Filter Support Tickets',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Support Tickets',
            description: 'Filter by category, priority, status, escalation tier, or assigned user to manage your support queue efficiently.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by category, priority, status, escalation tier, or assigned user to manage your support queue efficiently.',
            position: 'bottom',
        },
        {
            step_id: 'pw_create_ticket',
            target: '.dm-header button',
            title: 'Create a Support Ticket',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Support Ticket',
            description: 'Click here to open a ticket on behalf of a partner. The ticket is automatically linked to their service tier for SLA tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click here to open a ticket on behalf of a partner. The ticket is automatically linked to their service tier for SLA tracking.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 300,
        },
        {
            step_id: 'pw_ticket_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Support Ticket Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Support Ticket Form',
            description: "Enter the ticket title, description, partner organization, category, and priority. The SLA clock starts immediately based on the partner's service tier.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the ticket title, description, partner organization, category, and priority. The SLA clock starts immediately based on the partner's service tier.",
            position: 'right',
            action: { type: 'click', target: '.dm-form-actions > button:first-child' },
            duration_ms: 300,
        },
        {
            step_id: 'pw_complete',
            target: '.dm-page',
            title: 'Partner Workspace Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Partner Workspace Tour Complete',
            description: 'You can now onboard partners, configure service tiers with SLA commitments, track compliance deliverables, and manage the support lifecycle across your entire partner marketplace.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now onboard partners, configure service tiers with SLA commitments, track compliance deliverables, and manage the support lifecycle across your entire partner marketplace.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=partner-workspace.js.map